import type { IconButtonProps } from '@mui/material';
import { TasksIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';

const TasksIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.tasks', 'Tasks');

    return (
      <IconButton ref={ref} {...props} tooltipTitle={tooltipTitle}>
        <TasksIcon />
      </IconButton>
    );
  },
);

TasksIconButton.displayName = 'TasksIconButton';
export default TasksIconButton;
